 
//Ronco Scripts

$( document ).ready(function() {
   
  
  //Tab Swapper for product page
  $('#tab-bar-container .content-tab').click(function(e){
  	e.preventDefault();
    
    if($(this).hasClass('active')){
    	  
    } else {
      
      	let elTab = $(this).data('id'); 
    	$('#tab-bar-container .content-tab').removeClass('active');
      	$('#tab-content-container .content-container').removeClass('active');
      
      	$(this).addClass('active');
      	$('#' + elTab).addClass('active');
    }
  });
  
  
  if($('#shopify-section-popup').length > 0){
    setTimeout(function(){
      	$('#shopify-section-popup').find('.NewsletterPopup__Close').click();
    }, 45000)
  }
  
});